import React from 'react';

import { ILayout, ILayoutPage } from 'Module/Layout/Interface';
import { IAssociatesReport, IAssociatesReportFilters, IAssociatesReportResponse } from 'Module/AssociatesReport/Interface';
import { getAssociatesReportService } from 'Module/AssociatesReport/Service/Get/index';
import ApuracaoPage from '../Page/index';

function ApuracaoController(props: ILayoutPage) {
  const [showLoadingThisPage, setShowLoadingThisPage] = React.useState<boolean>(true);
  const [listApuracao, setListApuracao] = React.useState<[IAssociatesReport?]>([]);

  const toggleGetApuracao = React.useCallback(async () => {
    setShowLoadingThisPage(true);

    const filters: IAssociatesReportFilters = {
      codigo: '',
      nome: '',
      documento: '',
      active: 'Todos',
    };

    await getAssociatesReportService(filters)
      .then((response: IAssociatesReportResponse) => {
        const dataToUse = response.list || response.listResume || [];
        setListApuracao(dataToUse);
        setShowLoadingThisPage(false);
      })
      .catch((error: IAssociatesReportResponse) => {
        const layoutAlert: ILayout = {
          context: props.layout.context,
          titleMessage: 'Apuração',
          typeMessage: 'error',
          message: error.message || 'Erro ao carregar dados da apuração.',
          loading: false,
        };

        props.toggleSetLayout(layoutAlert);
        setListApuracao([]);
        setShowLoadingThisPage(false);
      });
  }, [props]);

  React.useEffect(() => {
    toggleGetApuracao();
  }, [toggleGetApuracao]);

  return (
    <ApuracaoPage
      {...props}
      showLoadingThisPage={showLoadingThisPage}
      listApuracao={listApuracao}
      toggleGetApuracao={toggleGetApuracao}
    />
  );
}

export default ApuracaoController;
